import React, { useState } from "react"
import { Row } from "antd"
import { TextTag, Button, PhoneInput } from "../../atoms"
import "./../MobileSignIn/MobileSignIn.scss"
import { connect } from "react-redux"
import { registerByMobile } from "../../redux/actionCreators/auth"
import { withRouter, Link } from "react-router-dom"
import {
  CREATE_ACCOUNT,
  ALREADY_REGISTERED,
  SIGN_UP_TO,
  BROWSER_INFO_MSG,
  LOGIN_BUTTON,
  INVALID_MOBILE,
  PRIVACY_POLICY,
  TERMS,
  TERMS_LINK,
  PRIVACY_POLICY_LINK,
  AND,
  CONTACT_YOU_PHONE_LABEL,
} from "../../constants/messages"
import SignUpSignInFooter from "../SignUpSignInFooter/SignUpSignInFooter"
import { formatPhoneNumber } from "../../utils/helpers"

const RegisterPartnerByMobile = (props) => {
  const { registerByMobile, isLoading } = props
  const [mobile, setMobile] = useState("")
  const [error, setError] = useState(true)
  const [errorMsg, setErrorMsg] = useState(true)
  const reg = new RegExp("[-() ]", "g")

  const handleChange = ({ value, error }) => {
    setMobile(value)
    setError(error)
  }

  const submitData = () => {
    if (localStorage.getItem("token")) return props.goToDashboard()
    else registerByMobile({ mobile: props.phoneNumber }, true)
  }

  let defaultPhoneNumber = props.phoneNumber
  if (defaultPhoneNumber) {
    const formattedPhoneNumber = formatPhoneNumber(defaultPhoneNumber)

    defaultPhoneNumber =
      formattedPhoneNumber && formattedPhoneNumber.intlCode
        ? `${formattedPhoneNumber.intlCode} ${formattedPhoneNumber.telephoneNumber}`
        : defaultPhoneNumber
  }

  return (
    <div className="mobile-sign-container">
      <div className="signin-text">
        <TextTag textType="spaceName">{SIGN_UP_TO}</TextTag>
        <div className="noacc-text">
          <TextTag textType="sectionTextPrimary">{ALREADY_REGISTERED}</TextTag>{" "}
          <Link to="/login">
            <TextTag textType="linkText"> {LOGIN_BUTTON}</TextTag>
          </Link>
        </div>
      </div>
      <div className="telephone invitee">
        <PhoneInput
          fieldId="register-partner-invite-phone"
          value={defaultPhoneNumber}
          disabled={true}
          allowDropdown={false}
          format={true}
          placeholder={CONTACT_YOU_PHONE_LABEL}
          onPhoneNumberFocus={(isValid, number, data, formattedValue) => {
            if (isValid) {
              let phoneNumber = formattedValue.replace(reg, "")
              setMobile(phoneNumber)
              setError(!isValid)
            } else {
              setError(!isValid)
              setErrorMsg(INVALID_MOBILE)
            }
          }}
        />
      </div>
      {error && <Row className="error-box">{errorMsg}</Row>}
      <Button
        btnSize="large"
        btnType="primary"
        className="login-form-button"
        onClick={submitData}
        disabled={isLoading}
      >
        {CREATE_ACCOUNT}
      </Button>
      <div className="email-link-msg">
        <SignUpSignInFooter />
      </div>
    </div>
  )
}
const mapStateToProps = (state) => ({
  isLoading: state.loadingState.isAuthenticating,
})

export default connect(mapStateToProps, { registerByMobile })(
  withRouter(RegisterPartnerByMobile)
)
